// src/services/storage/types.ts
// Interface abstraite pour le stockage local

export interface StorageService {
	// Opérations de base
	getItem(key: string): string | null;
	setItem(key: string, value: string): void;
	removeItem(key: string): void;
	clear(): void;

	// Utilitaires typés pour JSON
	getJSON<T>(key: string): T | null;
	setJSON<T>(key: string, value: T): void;

	// Vérification d'existence
	hasItem(key: string): boolean;
}

// Clés de stockage utilisées dans l'application
export const STORAGE_KEYS = {
	TOKEN: 'token',
	LANGUAGE: 'i18nextLng',
	PREFERENCES: 'gerositus.preferences',
	THEME_ID: 'theme-id',
	REDEEM_CODE: 'gerositusCode',
	PROJECTS_TYPE_FILTER: 'gerositus.projectsTypeFilter',
	PROJECTS_OWNERSHIP_FILTER: 'gerositus.projectsOwnershipFilter',
	PROJECTS_SEARCH: 'gerositus.projectsSearch'
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

